import React from "react";
import { formatNumber } from "utils/currencyFormat";
const TableContent = ({ dataTongQuatCuaHang }) => {
  return dataTongQuatCuaHang.map((item, index) => (
    <>
      <tr className="border-tq">
      </tr>
      <tr className="border-tq">
        <td rowSpan={2} className={
          index % 2 !== 0
            ? "color-line-td title-tr color-bg-1"
            : "color-line-td title-tr"
        }>
          {item.Name}
        </td>
        <td rowSpan={2} className="color-xanh-bold">{item.QuyTien !== 0 ? formatNumber(Math.round(item.QuyTien)) : 0}</td>
        <td rowSpan={2} className="color-do-bold">{item.TienVon !== 0 ? formatNumber(Math.round(item.TienVon)) : 0}</td>
        <td className="color-xanh-bold" >{item.CamDo_Thu !== 0 ? "+" + formatNumber(Math.round(item.CamDo_Thu)) : 0}</td>
        <td className="color-do-bold" >{formatNumber(Math.round(item.CamDo_Chi))}</td>
        <td className="color-xanh-bold" >{item.TinChap_Thu !== 0 ? "+" + formatNumber(Math.round(item.TinChap_Thu)) : 0}</td>
        <td className="color-do-bold" >{formatNumber(Math.round(item.TinChap_Chi))}</td>
        <td className="color-xanh-bold" >{item.TraGop_Thu !== 0 ? "+" + formatNumber(Math.round(item.TraGop_Thu)) : 0}</td>
        <td className="color-do-bold" >{formatNumber(Math.round(item.TraGop_Chi))}</td>
        <td className="color-xanh-bold" >{item.HuyDongVon_TienVay !== 0 ? "+" + formatNumber(Math.round(item.HuyDongVon_TienVay)) : 0}</td>
        <td className="color-do-bold" >{formatNumber(Math.round(item.HuyDongVon_TraLai))}</td>
        <td className="color-xanh-bold">{item.NgoaiLe_Thu !== 0 ? "+" + formatNumber(Math.round(item.NgoaiLe_Thu)) : 0}</td>
        <td className="color-do-bold">{formatNumber(Math.round(item.NgoaiLe_Chi))}</td>
        <td className="color-xanh-bold">{item.QuyNganHang_Thu !== 0 ? "+" + formatNumber(Math.round(item.QuyNganHang_Thu)) : 0}</td>
        <td className="color-do-bold">{formatNumber(Math.round(item.QuyNganHang_Chi))}</td>
        <td rowSpan={2} className="color-line-td color-do-bold" >{formatNumber(Math.round(item.RutQuy))}</td>
      </tr>
      <tr>
        <td className={index % 2 === 0 ? "color-line-td color-xanh2-bold" : "color-line-td color-xanh2-bold color-bg-1"} colSpan={2}>{formatNumber(Math.round(item.CamDo_Thu + item.CamDo_Chi))}</td>
        <td className={index % 2 === 0 ? "color-line-td color-xanh2-bold" : "color-line-td color-xanh2-bold color-bg-1"} colSpan={2}> {formatNumber(Math.round(item.TinChap_Thu + item.TinChap_Chi))}</td>
        <td className={index % 2 === 0 ? "color-line-td color-xanh2-bold" : "color-line-td color-xanh2-bold color-bg-1"} colSpan={2}> {formatNumber(Math.round(item.TraGop_Thu + item.TraGop_Chi))}</td>
        <td className={index % 2 === 0 ? "color-line-td color-xanh2-bold" : "color-line-td color-xanh2-bold color-bg-1"} colSpan={2}>{formatNumber(Math.round(item.HuyDongVon_TienVay + item.HuyDongVon_TraLai))}</td>
        <td className={index % 2 === 0 ? "color-line-td color-xanh2-bold" : "color-line-td color-xanh2-bold color-bg-1"} colSpan={2}>{formatNumber(Math.round(item.NgoaiLe_Thu + item.NgoaiLe_Chi))}</td>
        <td className={index % 2 === 0 ? "color-line-td color-xanh-bold" : "color-line-td color-xanh-bold color-bg-1"} colSpan={2}>{formatNumber(Math.round(item.QuyNganHang_Thu + item.QuyNganHang_Chi))}</td>
      </tr>
    </>
  ));
};

export default TableContent;